import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Typography, mediaQuery } from '@lacedltd/laced-components'

export const Container = styled.div({
  maxWidth: '29.875rem',
  width: '100%',
  margin: '0 auto',
  flex: '1',
  padding: `${tokens.spacing[9]} ${tokens.spacing[6]} ${tokens.spacing[12]}`,
  [mediaQuery.m.min]: {
    padding: `${tokens.spacing[11]} 0 ${tokens.spacing[13]}`
  }
})

export const Paragraph = styled(Typography.Text)({
  marginBottom: tokens.spacing[8]
})

export const ButtonLink = styled.a({
  width: '100%',
  [mediaQuery.m.min]: { width: 'fit-content' }
})
